export default {
  LICENSE_NO_REPEAT_EMAIL: '添加的邮箱不能重复',
  LICENSE_NO_NOTICED_EMAIL: '暂无通知的邮箱',
  LICENSE_FIXED_DESK: '固定工位({val}个)',
  LICENSE_HOT_DESK: '共享工位({val}个)',
  LICENSE_EMAIL_NO_MORE_TEN: '接收通知的邮箱个数不能超过10个',
  LICENSE_AUTHORIZED: '已授权',
  LICENSE_NOT_AUTHORIZED: '未授权'
}
